import { useCallback, useEffect, useRef, useState } from "react";
import "./Gallery.css";
import ImageList from "./ImageList";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [checked, setChecked] = useState(false);
  const [allowFetch, setAllowFetch] = useState(false);
  const [id, setUpdateId] = useState(0);
  const viewed = new Set();
  const containerRef = useRef();

  function autoFetch() {
    setAllowFetch(!allowFetch);
  }

  function filterViewed(items) {
    if (items.length === 0) {
      console.log("error no items");
    }
    const result = items.filter((item) => {
      return !viewed.has(item.id);
    });

    items.forEach((item) => {
      viewed.add(item.id);
    });
    return result;
  }

  const fetchImages = useCallback(() => {
    fetch("https://dog.ceo/api/breeds/image/random")
      .then((response) => {
        console.log(response);
        if (response.ok) return response.json();
      })
      .then((data) => {
        setImages([...images, { src: data.message, id: id }]);
        setUpdateId((id) => id + 1);
        console.log(id);
      });
    fetch("https://random-d.uk/api/v2/random")
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((data) => {
        setImages([...images, { src: data.url, id: id }]);
        setUpdateId((id) => id + 1);
        console.log(id);
      });
  });

  const shouldGetMoreContent = useCallback(() => {
    // Fetch if more than 90% of scroll width
    return (
      //   containerRef.current.scrollLeft === 0 ||
      containerRef.current.scrollLeft + containerRef.current.offsetWidth >=
      0.9 * containerRef.current.scrollWidth
    );
  }, [containerRef]);

  useEffect(() => {
    if (allowFetch) {
      const interval = window.setInterval(() => {
        if (shouldGetMoreContent()) {
          fetchImages();
        }
      }, 2 * 1000);

      return () => clearInterval(interval);
    }
  }, [allowFetch, fetchImages, shouldGetMoreContent]);

  return (
    <div>
      <div>
        <button onClick={fetchImages}>Get images</button>
        <button onClick={autoFetch}>
          {allowFetch ? "Stop auto-fetch" : "Auto-fetch images"}
        </button>
        <label>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => {
              setChecked(!checked);
            }}
          />
          Autoscroll
        </label>
      </div>
      <ImageList innerRef={containerRef} images={images} autoscroll={checked} />
    </div>
  );
}
